import { render, staticRenderFns } from "./ProjectTypeSelectorMenuSelect.vue?vue&type=template&id=936d0dd6&"
import script from "./ProjectTypeSelectorMenuSelect.vue?vue&type=script&lang=js&"
export * from "./ProjectTypeSelectorMenuSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports